import { motion } from "framer-motion";
import React, { useState } from "react";
import data_ani from "../../assets/data_ani.gif";
import aa from "../../assets/nn.gif";

import { AppWrap } from "../../wrapper";
import { AIChatModal, VoiceAssistant } from "../../components";

import { images } from "../../constants";
import "./Header.scss";

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
};

const Header = () => {
  const [isAIChatOpen, setIsAIChatOpen] = useState(false);
  const [showVoiceAssistant, setShowVoiceAssistant] = useState(false);

  const handleResumeClick = () => {
    window.open(
      "https://drive.google.com/file/d/1m5iN5JOahvCqr30DyL-dB9f9jIZ6ei5W/view?usp=sharing",
      "_blank",
    );
  };

  const handleAIChatClick = () => {
    setIsAIChatOpen(true);
  };

  const handleMicClick = () => {
    setShowVoiceAssistant(true);
  };

  const handleVoiceCommand = (command, value) => {
    if (command === "navigate") {
      // Navigate to sections
      const sectionId = value.replace("#", "");
      const section = document.getElementById(sectionId);
      if (section) {
        setShowVoiceAssistant(false);
        setTimeout(() => {
          section.scrollIntoView({ behavior: "smooth" });
        }, 300);
      }
    } else if (command === "open") {
      // Open external links
      const links = {
        resume:
          "https://drive.google.com/file/d/1m5iN5JOahvCqr30DyL-dB9f9jIZ6ei5W/view?usp=sharing",
        github: "https://github.com/Dhrumit1314",
        linkedin: "https://linkedin.com/in/dhrumitpatelds",
        huggingface: "https://huggingface.co/Dhrumit1314",
      };

      if (links[value]) {
        window.open(links[value], "_blank");
      }
    }
  };

  const handleVoiceQuestion = (question) => {
    // For voice questions, open the AI chat modal with the question
    setIsAIChatOpen(true);
    setShowVoiceAssistant(false);
    // You can pass the question to the AI chat modal if needed
  };

  const handleCloseVoiceAssistant = () => {
    setShowVoiceAssistant(false);
  };

  return (
    <div className="app__header app__flex">
      <motion.div
        whileInView={{ x: [-100, 0], opacity: [0, 1] }}
        transition={{ duration: 0.5 }}
        className="app__header-info"
      >
        <div className="app__header-badge">
          <div className="badge-cmp app__flex">
            <span>👋</span>
            <div style={{ marginLeft: 20 }}>
              <p className="p-text">Hello, I am</p>
              <h1 className="head-text">Dhrumit Patel</h1>
            </div>
          </div>

          <div className="tag-cmp app__flex">
            <p className="p-text">AI & ML Model Architect</p>
            <p className="p-text">Researcher in AI & Data Science</p>
            <p className="p-text">Empowering Data-Driven Solutions</p>
          </div>
        </div>
      </motion.div>

      <motion.div
        whileInView={{ opacity: [0, 1], delayChildren: 0.5 }}
        transition={{ duration: 0.5 }}
        className="app__header-img"
      >
        <img src={aa} alt="profile_bg" className="data_ani" />
        <motion.img
          whileInView={{ scale: [0, 1] }}
          transition={{ duration: 1, ease: "easeInOut" }}
          src={images.circle}
          alt="profile_circle"
          className="overlay_circle"
        />
      </motion.div>

      <motion.div
        variant={scaleVariants}
        whileInView={scaleVariants.whileInView}
        className="app__header-circles"
      >
        {[images.pandas, images.tensorflow, images.numpy, images.keras].map(
          (circle, index) => (
            <div className="circle-cmp app_flex" key={`circle-${index}`}>
              <img src={circle} alt="circle" />
            </div>
          ),
        )}
      </motion.div>

      {/* Buttons section */}
      <motion.div className="app__header-buttons">
        <button onClick={handleResumeClick} className="resume-button">
          View/Download Resume
        </button>
        <button onClick={handleAIChatClick} className="ai-chat-button">
          🤖 Chat with AI Assistant
        </button>
      </motion.div>

      {/* Voice Assistant Mic Icon */}
      <motion.div
        className="app__header-mic"
        whileInView={{ scale: [0, 1], opacity: [0, 1] }}
        transition={{ duration: 0.5, delay: 0.3 }}
      >
        <motion.button
          onClick={
            showVoiceAssistant ? handleCloseVoiceAssistant : handleMicClick
          }
          className={`mic-button ${showVoiceAssistant ? "close-icon" : ""}`}
          title={
            showVoiceAssistant ? "Close Voice Assistant" : "Voice Assistant"
          }
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          transition={{ duration: 0.2 }}
        >
          <motion.span
            key={showVoiceAssistant ? "close" : "mic"}
            initial={{ opacity: 0, rotate: -90, scale: 0.5 }}
            animate={{ opacity: 1, rotate: 0, scale: 1 }}
            exit={{ opacity: 0, rotate: 90, scale: 0.5 }}
            transition={{
              duration: 0.3,
              ease: "easeInOut",
              type: "spring",
              stiffness: 300,
              damping: 20,
            }}
          >
            {showVoiceAssistant ? "✕" : "🎤"}
          </motion.span>
        </motion.button>
      </motion.div>

      {/* Voice Assistant */}
      {showVoiceAssistant && (
        <VoiceAssistant
          onVoiceCommand={handleVoiceCommand}
          onVoiceQuestion={handleVoiceQuestion}
          onClose={handleCloseVoiceAssistant}
        />
      )}

      {/* AI Chat Modal */}
      <AIChatModal
        isOpen={isAIChatOpen}
        onClose={() => setIsAIChatOpen(false)}
      />
    </div>
  );
};

export default AppWrap(Header, "home");
